import React from 'react';
import { Link } from 'react-router-dom';
import './css/accouting-packages.css';

const pricingPlans = [
	{
		name: 'Small Business',
		description: 'Up to 120 transactions per month',
		price: 'LKR 28,500 / month',
		items: [
			{
				title: 'Account reconciliation',
				price: 'LKR 9,000',
				features: [
					'Bank accounts up to 3',
					'Credit card accounts up to 3',
					'Reconcile electronic transactions into an Accounting Package',
				],
			},
			{
				title: 'Monthly financials',
				price: 'LKR 8,000',
				features: ['Balance Sheet', 'Profit & Loss', 'General Ledger', 'Statement of Cash Flows'],
			},
			{
				title: 'Stock Records',
				price: 'LKR 2,500',
				features: ['Stock report up to 20 items'],
			},
			{
				title: 'Employee Funds',
				price: 'LKR 2,500',
				features: ['EPF & ETF returns up to 5 employees', 'Annual return'],
			},
			{
				title: 'Advice',
				price: 'LKR 2,000',
				features: ['Accountant and business service meeting up to an hour'],
			},
			{
				title: 'Software and portals',
				price: 'LKR 4,500',
				features: [
					'Essential document storage',
					'Accounting software setup & maintenance',
					'Expense management with one criterion',
				],
			},
		],
	},
	{
		name: 'Small Business Plus',
		description: 'Up to 125-240 transactions per month',
		price: 'LKR 38,500 / month',
		items: [
			{
				title: 'Account reconciliation',
				price: 'LKR 12,000',
				features: [
					'Bank accounts up to 5',
					'Credit card accounts up to 5',
					'Reconcile electronic transactions into an Accounting Package',
				],
			},
			{
				title: 'Monthly financials',
				price: 'LKR 10,000',
				features: ['Balance Sheet', 'Profit & Loss', 'General Ledger', 'Statement of Cash Flows'],
			},
			{
				title: 'Stock Records',
				price: 'LKR 4,000',
				features: ['Stock report up to 20 items'],
			},
			{
				title: 'Employee Funds',
				price: 'LKR 4,000',
				features: ['EPF & ETF returns up to 5 employees', 'Annual return'],
			},
			{
				title: 'Advice',
				price: 'LKR 5,000',
				features: ['CFO and business service meeting up to an hour'],
			},
			{
				title: 'Training',
				price: 'LKR 5,000',
				features: ['Necessary software training'],
			},
			{
				title: 'Software and portals',
				price: 'LKR 7,500',
				features: [
					'Essential document storage',
					'Accounting software setup & maintenance',
					'Expense management with two criteria',
					'Optional monthly performance report with key performance indicators (KPIs)',
					'Class tracking',
				],
			},
		],
	},
	{
		name: 'Small Business Advanced',
		description: '250+ transactions per month',
		price: 'Custom Pricing',
		items: [
			{
				title: 'Account reconciliation',
				features: [
					'Bank accounts up to 5',
					'Credit card accounts up to 5',
					'Reconcile electronic transactions into an Accounting Package',
				],
			},
			{
				title: 'Monthly financials',
				features: ['Balance Sheet', 'Profit & Loss', 'General Ledger', 'Statement of Cash Flows'],
			},
			{
				title: 'Stock Records',
				features: ['Stock system'],
			},
			{
				title: 'Employee Funds',
				features: ['EPF & ETF returns up to 5 employees', 'Annual return', 'PAYE'],
			},
			{
				title: 'Advice & Training',
				features: [
					'General business consulting',
					'Strategic planning',
					'Tax planning',
					'Necessary software training',
					'Business advisory service',
				],
			},
			{
				title: 'Software and portals',
				features: [
					'Essential document storage',
					'Accounting software setup & maintenance',
					'Expense management',
					'Optional monthly performance report with key performance indicators (KPIs)',
					'Class and location tracking',
				],
			},
		],
	},
];

function PricingItem({ title, price, features }) {
	return (
		<div className="accounting-pricing-card__item">
			<div className="accounting-pricing-card__item-top">
				<h3>{title}</h3>
				{price ? <span>{price}</span> : null}
			</div>
			<ul className="accounting-pricing-card__features">
				{features.map((feature) => (
					<li key={feature}>{feature}</li>
				))}
			</ul>
		</div>
	);
}

function PricingCard({ name, description, price, items }) {
	return (
		<article className="accounting-pricing-card">
			<div className="accounting-pricing-card__header">
				<p className="accounting-pricing-card__name">{name}</p>
				<p className="accounting-pricing-card__description">{description}</p>
				<p className="accounting-pricing-card__price">{price}</p>
			</div>
			<div className="accounting-pricing-card__body">
				{items.map((item) => (
					<PricingItem key={`${name}-${item.title}`} {...item} />
				))}
			</div>
			<Link className="accounting-pricing-card__action" to="/contact">
				Send Your Request
			</Link>
		</article>
	);
}

export default function AccountingPackages() {
	return (
		<section className="accounting-pricing-section pricingContainer">
			<div className="accounting-pricing-section__inner">
				<div className="accounting-pricing-section__grid">
					{pricingPlans.map((plan) => (
						<PricingCard key={plan.name} {...plan} />
					))}
				</div>
			</div>
		</section>
	);
}
